const SMALL_SIZE = 'small';
const MEDIUM_SIZE = 'medium';
const LARGE_SIZE = 'large';

export const PEAK_SIZES = [SMALL_SIZE, MEDIUM_SIZE, LARGE_SIZE];

export const MAX_WIDTHS = [LARGE_SIZE];
